import React from "react";

const MindIsKing = () => {
  return (
    <div className="bg-cover bg-no-repeat bg-center bg-mind-power-bg min-h-screen"></div>
  );
};

export default MindIsKing;
